import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ManualSubmissionProgressPanel from '../components/ManualSubmission/ManualSubmissionProgressPanel';

export default function ManualSubmissionProgressPage() {
  const { buildingId } = useParams();
  const navigate = useNavigate();

  return (
    <div
      className="home-container page-animate"
      style={{
        width: '100%',
        maxWidth: 'calc(100vw - var(--sidebar-current-width) - 40px)',
        margin: '0 auto',
        paddingLeft: 20,
        paddingRight: 20,
        paddingBottom: 24,
        overflowX: 'hidden',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 10, flexWrap: 'wrap' }}>
        <button className="rc-btn" onClick={() => navigate(-1)}>
          Назад
        </button>
      </div>

      <ManualSubmissionProgressPanel buildingId={buildingId} />
    </div>
  );
}
